import Ws from "../../providers/Ws";

export default class  FromServer{

    getData = async () =>{

        let ws = new Ws();

        let _bugete =  ws.customSelect('select * from bugete_tipuri where isnull(inactiv,0) != @p1 order by id desc',{
            p1:1
        });

        let _costuri = ws.customSelect('select * from proiecte_costuri_tipuri where isnull(inactiv,0) != @p1 order by id desc',{
            p1:1
        })

        

        let [bugete,costuri] = await Promise.all([_bugete, _costuri]);


        // console.log('bugete :', bugete);

        if(bugete.Succes && costuri.Succes){

            let obj = {bugete:bugete.Content, costuri:costuri.Content}

            return obj
        }
        
    }


}